import { useTranslation } from "react-i18next";

export const GROUP_ORDER = ["A", "AA", "B", "C", "D", "E", "F", "G", "DA", "EA", "FA", "J", "SFT", "M", "K", "SFE", "L", "STP", "SGC", "SGT", "SVS", "H", "I", "N"];

export const SORTS = [
  { v: "recommended", l: "Recommended" },
  { v: "price_asc", l: "Price: Low to High" },
  { v: "price_desc", l: "Price: High to Low" },
  { v: "featured", l: "Featured" },
  { v: "best_value", l: "Best Value" },
];

export const DEFAULT_FILTERS = { q: "", group: "All", vtype: "all", seats: "any", sort: "recommended" };

export const applyFilters = (vehicles, f) => {
  const q = (f.q || "").trim().toLowerCase();
  let out = vehicles.filter((v) =>
    (f.group === "All" || v.group === f.group) &&
    (f.vtype === "all" || v.group_label === f.vtype) &&
    (f.seats === "any" || v.seats >= Number(f.seats)) &&
    (!q || [v.name, v.acriss, v.group_label, ...(v.features || [])].join(" ").toLowerCase().includes(q)));
  if (f.sort === "price_asc") out = [...out].sort((a, b) => a.daily_incl - b.daily_incl);
  if (f.sort === "price_desc") out = [...out].sort((a, b) => b.daily_incl - a.daily_incl);
  if (f.sort === "featured") out = [...out].sort((a, b) => (b.model_guaranteed - a.model_guaranteed) || ((b.insurance_tier === "premium") - (a.insurance_tier === "premium")) || b.daily_incl - a.daily_incl);
  if (f.sort === "best_value") out = [...out].sort((a, b) => a.weekly_incl / 7 - b.weekly_incl / 7);
  return out;
};

export const FleetFilters = ({ vehicles, filters, setFilters }) => {
  const { t } = useTranslation();
  const counts = vehicles.reduce((m, v) => ({ ...m, [v.group]: (m[v.group] || 0) + 1 }), {});
  const types = [...new Set(vehicles.map((v) => v.group_label))].sort();
  const set = (k, val) => setFilters({ ...filters, [k]: val });
  const sel = "field-input !py-1.5 !text-xs w-auto";

  return (
    <div className="space-y-4" data-testid="fleet-filters">
      <div className="flex flex-wrap gap-2" data-testid="fleet-group-chips">
        <button onClick={() => set("group", "All")}
          className={`text-xs font-medium px-3 py-1.5 rounded-full border transition-colors ${filters.group === "All" ? "bg-[#009900] text-white border-[#009900]" : "bg-white text-[#144733] border-[#d5ddd5] hover:border-[#009900]"}`}
          data-testid="fleet-group-all">{t("All Fleet {{n}}", { n: vehicles.length })}</button>
        {GROUP_ORDER.filter((g) => counts[g]).map((g) => (
          <button key={g} onClick={() => set("group", g)}
            className={`text-xs font-medium px-3 py-1.5 rounded-full border transition-colors ${filters.group === g ? "bg-[#009900] text-white border-[#009900]" : "bg-white text-[#144733] border-[#d5ddd5] hover:border-[#009900]"}`}
            data-testid={`fleet-group-chip-${g}`}>{t("Group {{g}} {{n}}", { g, n: counts[g] })}</button>
        ))}
      </div>
      <div className="flex flex-wrap gap-3 items-center text-xs text-[#57685e]">
        <input type="search" className="field-input !py-1.5 !text-xs w-56" placeholder={t("Search model, feature or ACRISS…")}
          value={filters.q} onChange={(e) => set("q", e.target.value)} data-testid="fleet-search-input" />
        <label className="flex items-center gap-1.5">{t("Type:")}
          <select className={sel} value={filters.vtype} onChange={(e) => set("vtype", e.target.value)} data-testid="fleet-filter-type">
            <option value="all">{t("All Types")}</option>
            {types.map((tp) => <option key={tp} value={tp}>{tp}</option>)}
          </select>
        </label>
        <label className="flex items-center gap-1.5">{t("Seats:")}
          <select className={sel} value={filters.seats} onChange={(e) => set("seats", e.target.value)} data-testid="fleet-filter-seats">
            <option value="any">{t("Any")}</option><option value="4">{t("4+ Passengers")}</option><option value="5">{t("5+ Passengers")}</option><option value="7">{t("7+ Passengers")}</option>
          </select>
        </label>
        <label className="flex items-center gap-1.5">{t("Sort:")}
          <select className={sel} value={filters.sort} onChange={(e) => set("sort", e.target.value)} data-testid="fleet-filter-sort">
            {SORTS.map((s) => <option key={s.v} value={s.v}>{t(s.l)}</option>)}
          </select>
        </label>
        <button onClick={() => setFilters(DEFAULT_FILTERS)} className="text-[#009900] font-semibold" data-testid="fleet-filter-reset">{t("Reset")}</button>
      </div>
    </div>
  );
};
